import { useEffect } from 'react';

const useAnimation = (data, key, setAnimatedState, resetKey) => {
  useEffect(() => {
    const intervals = [];

    data.forEach((item) => {
      let start = 0;
      const end = item[key];
      const duration = 1000;
      const stepTime = 50;
      const steps = duration / stepTime;
      const increment = end / steps;

      const interval = setInterval(() => {
        start += increment;
        setAnimatedState((prev) => ({
          ...prev,
          [item.id]: Math.min(Math.round(start), end),
        }));

        if (start >= end) clearInterval(interval);
      }, stepTime);

      intervals.push(interval);
    });

    return () => intervals.forEach(clearInterval);
  }, [data, key, resetKey]);
};

export default useAnimation;
